"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebProviderFactory = void 0;
const out_1 = require("@multiversx/sdk-web-wallet-provider/out");
const AuthProviders_1 = require("../AuthProviders");
const network_1 = require("../network");
const EventBus_1 = __importDefault(require("../EventBus"));
class WebProviderFactory {
    constructor(env) {
        this.connectionOptions = {};
        this.address = null;
        const networkOptions = network_1.network[env];
        this.networkAddress = networkOptions.walletAddress;
    }
    setConnectionOptions(value) {
        this.connectionOptions = value;
        return this;
    }
    setAddress(value) {
        this.address = value;
        return this;
    }
    createProvider() {
        const provider = new out_1.WalletProvider(this.networkAddress);
        return new AuthProviders_1.WebProvider(provider, this.connectionOptions, new EventBus_1.default(), this.address);
    }
}
exports.WebProviderFactory = WebProviderFactory;
